import keyBy from 'lodash/keyBy';
import { createSlice } from '@reduxjs/toolkit';
// utils
import axios from '../../utils/axios';
import { SERVER_API } from '../../config-global';

// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,
  error: null,
  contacts: { byId: {}, allIds: [] },
  conversations: { byId: {}, allIds: [] },
  activeConversationId: null,
  participants: [],
  recipients: [],
  ChatHistoryID: null,
  ChatHistoryList: [],
};

const slice = createSlice({
  name: 'chat',
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    // GET CONTACT SSUCCESS
    getContactsSuccess(state, action) {
      const contacts = action.payload;

      state.contacts.byId = keyBy(contacts, 'id');
      state.contacts.allIds = Object.keys(state.contacts.byId);
    },

    // GET CONVERSATIONS
    getConversationsSuccess(state, action) {
      const conversations = action.payload;

      state.conversations.byId = keyBy(conversations, 'id');
      state.conversations.allIds = Object.keys(state.conversations.byId);
    },

    // GET CONVERSATION
    getConversationSuccess(state, action) {
      const conversation = action.payload;

      if (conversation) {
        state.conversations.byId[conversation.id] = conversation;
        state.activeConversationId = conversation.id;
        if (!state.conversations.allIds.includes(conversation.id)) {
          state.conversations.allIds.push(conversation.id);
        }
      } else {
        state.activeConversationId = null;
      }
    },

    // ON SEND MESSAGE
    sendMessage(state, action) {
      const conversation = action.payload;
      const { conversationId, messageId, message, contentType, attachments, createdAt, senderId } =
        conversation;

      const newMessage = {
        id: messageId,
        body: message,
        contentType,
        attachments,
        createdAt,
        senderId,
      };

      state.conversations.byId[conversationId].messages.push(newMessage);
    },

    markConversationAsReadSuccess(state, action) {
      const { conversationId } = action.payload;
      const conversation = state.conversations.byId[conversationId];
      if (conversation) {
        conversation.unreadCount = 0;
      }
    },

    // GET PARTICIPANTS
    getParticipantsSuccess(state, action) {
      const participants = action.payload;
      state.participants = participants;
    },

    // RESET ACTIVE CONVERSATION
    resetActiveConversation(state) {
      state.activeConversationId = null;
    },

    addRecipients(state, action) {
      const recipients = action.payload;
      state.recipients = recipients;
    },

    AdminDashboard_AIAssistBox_Create_AIChatHistorySuccess(state, action) {
      state.isLoading = false;
      state.ChatHistoryID = action.payload;
    },

    AdminDashboard_AIAssistBox_Delete_AIChatHistorySuccess(state, action) {
      const chatId = action.payload.ChatHistoryID;
      state.isLoading = false;
      state.ChatHistoryList = state.ChatHistoryList.map(chat =>
        chat.ChatHistoryID === chatId ? { ...chat, delInd: 1 } : chat
      );
    },

    AdminDashboard_AIAssistBox_Select_All_AIChatHistorySuccess(state, action) {
      state.isLoading = false;
      state.ChatHistoryList = action.payload;
    }
  },
});

// Reducer
export default slice.reducer;

// Actions
export const { addRecipients, sendMessage, resetActiveConversation } = slice.actions;

// ----------------------------------------------------------------------

export function getContacts() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get('/api/chat/contacts');
      dispatch(slice.actions.getContactsSuccess(response.data.contacts));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function getConversations() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get('/api/chat/conversations');
      dispatch(slice.actions.getConversationsSuccess(response.data.conversations));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function getConversation(conversationKey) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get('/api/chat/conversation', {
        params: { conversationKey },
      });
      dispatch(slice.actions.getConversationSuccess(response.data.conversation));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function markConversationAsRead(conversationId) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      await axios.get('/api/chat/conversation/mark-as-seen', {
        params: { conversationId },
      });
      dispatch(slice.actions.markConversationAsReadSuccess({ conversationId }));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function getParticipants(conversationKey) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get('/api/chat/participants', {
        params: { conversationKey },
      });
      dispatch(slice.actions.getParticipantsSuccess(response.data.participants));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

//-----------------------------
// export function AdminDashboard_AIAssistBox_Create_AIChatHistory(chatHistoryId, id, title, location) {
//   return async (dispatch) => {
//     dispatch(slice.actions.startLoading());

//     try {
//       const url = `${SERVER_API}AdminDashboard_AIAssistBox_Create_AIChatHistory?JsonID=${id}&title=${encodeURIComponent(title)}&location=${encodeURIComponent(location)}&ChatHistoryID=${chatHistoryId != null ? chatHistoryId : ''}`;
//       const response = await fetch(url);

//       const result = await response.json();
// console
//       if (result && result.ReturnVal === 1) {
//         dispatch(slice.actions.AdminDashboard_AIAssistBox_Create_AIChatHistorySuccess(result.ChatHistoryID));
//       } else {
//         dispatch(slice.actions.hasError(result.ReturnSqlError || "Unknown error"));
//       }
//     } catch (error) {
//       dispatch(slice.actions.hasError(error.message || "API error"));
//     }
//   };
// }

export function AdminDashboard_AIAssistBox_Create_AIChatHistory(chatHistoryId, id, title, location) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());

    try {
      const requestUrl = `${SERVER_API}AdminDashboard_AIAssistBox_Create_AIChatHistory?JsonID=${id}&title=${encodeURIComponent(title)}&location=${encodeURIComponent(location)}&ChatHistoryID=${chatHistoryId != null ? chatHistoryId : ''}`;
      console.log('Request URL:', requestUrl);
      const response = await fetch(requestUrl);
      const result = JSON.parse(await response.json());

      if (result[0].ReturnVal === 1) {
        dispatch(slice.actions.AdminDashboard_AIAssistBox_Create_AIChatHistorySuccess(JSON.parse(result[0].ReturnData)));
    
        return result[0].ReturnData;
      }

      dispatch(slice.actions.hasError(result[0].ReturnMsg));
      return null;
    } catch (error) {
      dispatch(slice.actions.hasError(error.message));
      return null;
    }
  };
}


//-----------------------------
// export function AdminDashboard_AIAssistBox_Delete_AIChatHistory(chatHistoryId, id, title, location) {
//   return async (dispatch) => {
//     dispatch(slice.actions.startLoading());

//     try {
//       const url = `${SERVER_API}AdminDashboard_AIAssistBox_Delete_AIChatHistory?JsonID=${id}&title=${title}&location=${location}&ChatHistoryID=${chatHistoryId}`;
//       console.log("📤 Request URL:", url);
//       const response = await fetch(url);
//       const result = await response.json();

//       if (result && result.ReturnVal === 1) {
//         dispatch(slice.actions.AdminDashboard_AIAssistBox_Delete_AIChatHistorySuccess(chatHistoryId));
//       } else {
//         console.error("❌ DB delete failed:", result);
//         dispatch(slice.actions.hasError(result.ReturnSqlError || "Unknown error"));
//       }
//     } catch (error) {
//       console.error("❌ Network/API error:", error);
//       dispatch(slice.actions.hasError(error.message || "API error"));
//     }
//   };
// }

//-----------------------------
export function AdminDashboard_AIAssistBox_Delete_AIChatHistory({ ChatHistoryID, JsonID }) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());

    try {
      const url = `${SERVER_API}AdminDashboard_AIAssistBox_Delete_AIChatHistory?JsonID=${encodeURIComponent(JsonID)}`;
      console.log("📤 Request URL:", url);

      const response = await fetch(url);
      const result = await response.json();

      if (result && result.ReturnVal === 1) {
        // ✅ 传入 ChatHistoryID，给 reducer 用
        dispatch(slice.actions.AdminDashboard_AIAssistBox_Delete_AIChatHistorySuccess({
          ChatHistoryID,
        }));
      } else {
        console.error("Soft delete done:", result);
        dispatch(slice.actions.hasError(result.ReturnSqlError || "Unknown error"));
      }
    } catch (error) {
      console.error("❌ Network/API error:", error);
      dispatch(slice.actions.hasError(error.message || "API error"));
    }
  };
}

//-----------------------------
// export function AdminDashboard_AIAssistBox_Delete_AIChatHistory({ ChatHistoryID, jsonId, delInd }) {
//   return async (dispatch) => {
//     dispatch(slice.actions.startLoading());

//     try {
//       const url = `${SERVER_API}AdminDashboard_AIAssistBox_Delete_AIChatHistory?JsonID=${encodeURIComponent(jsonId)}`;

//       const response = await fetch(url, {
//         method: 'POST',
//         headers: {
//           'Content-Type': 'application/json',
//         },
//         body: JSON.stringify({
//           ChatHistoryID,
//           jsonId,
//           delInd: delInd ?? 1,
//         }),
//       });

//       const result = await response.json();
//       console.log("📥 Server response:", result);

//       if (result && result.ReturnVal === 1) {
//         dispatch(slice.actions.AdminDashboard_AIAssistBox_Delete_AIChatHistorySuccess(ChatHistoryID));
//       } else {
//         console.error("❌ DB delete failed:", result);
//         dispatch(slice.actions.hasError(result.ReturnSqlError || "Unknown error"));
//       }
//     } catch (error) {
//       console.error("❌ Network/API error:", error);
//       dispatch(slice.actions.hasError(error.message || "API error"));
//     }
//   };
// }

//-----------------------------
// export function AdminDashboard_AIAssistBox_Select_All_AIChatHistory() {
//   return async (dispatch) => {
//     dispatch(slice.actions.startLoading());

//     try {
//       const url = `${SERVER_API}AdminDashboard_AIAssistBox_Select_All_AIChatHistory`;
//       console.log("📤 Request URL:", url);

//       const response = await fetch(url);
//       const result = await response.json();

//       if (result.Message) {
//         dispatch(slice.actions.hasError(result.Message));
//         return;
//       }

//       const data = Array.isArray(result) ? result[0] : result;

//       if (data.ReturnVal === 1) {
//         const parsedData = JSON.parse(data.ReturnData);
//         dispatch(slice.actions.AdminDashboard_AIAssistBox_Select_All_AIChatHistorySuccess(parsedData));
//       } else {
//         dispatch(slice.actions.hasError(data.ReturnSqlError || "Unknown error"));
//       }
//     } catch (error) {
//       dispatch(slice.actions.hasError(error.message || "API error"));
//     }
//   };
// }

//-----------------------------
export function AdminDashboard_AIAssistBox_Select_All_AIChatHistory() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await fetch(
        `${SERVER_API}AdminDashboard_AIAssistBox_Select_All_AIChatHistory`
      );
      const json = await response.json();
      if (json.Message) {
        dispatch(slice.actions.hasError(json.Message));
      } else {
        const data = JSON.parse(json)[0];
        if (data.ReturnVal === 1) {
          const eventData = JSON.parse(data.ReturnData);
          dispatch(slice.actions.AdminDashboard_AIAssistBox_Select_All_AIChatHistorySuccess(eventData));
        } else {
          dispatch(slice.actions.hasError(data.ReturnSqlError));
        }
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}